import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Toaster } from 'sonner';
import { Analytics } from '@vercel/analytics/react';
import { inject } from '@vercel/analytics';
import App from './App';
import './index.css';
import { initErrorTracking } from './utils/errorTracking';
import { initializePixel } from './utils/metaPixel';

// Initialize analytics
inject();

// Initialize error tracking
initErrorTracking();

// Initialize Meta Pixel
initializePixel();

// Add performance monitoring
if ('performance' in window && 'PerformanceObserver' in window) {
  // Create performance observer for Core Web Vitals
  const observer = new PerformanceObserver((list) => {
    list.getEntries().forEach((entry) => {
      console.log('[Performance]', entry.name, entry.value);
    });
  });

  // Observe paint timing and other metrics
  observer.observe({ 
    entryTypes: [
      'paint',
      'largest-contentful-paint',
      'first-input',
      'layout-shift'
    ] 
  });
}

// Preconnect to external domains
const preconnectLinks = [
  'https://images.unsplash.com',
  'https://fonts.googleapis.com',
  'https://fonts.gstatic.com',
  'https://connect.facebook.net'
];

preconnectLinks.forEach(href => {
  const link = document.createElement('link');
  link.rel = 'preconnect';
  link.href = href;
  document.head.appendChild(link);
});

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');

createRoot(rootElement).render(
  <StrictMode>
    <App />
    <Toaster position="top-right" richColors />
    <Analytics />
  </StrictMode>
);